export const GET_CARFAX = 'GET_CARFAX';
export const GET_CARFAX_SUCCESS = 'GET_CARFAX_SUCCESS';
export const GET_CARFAX_ERROR = 'GET_CARFAX_ERROR';

export const POST_EXTERNAL_CARFAX = 'POST_EXTERNAL_CARFAX';
export const POST_EXTERNAL_CARFAX_SUCCESS = 'POST_EXTERNAL_CARFAX_SUCCESS';
export const POST_EXTERNAL_CARFAX_ERROR = 'POST_EXTERNAL_CARFAX_ERROR';
